"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setColorsForThemeV2 = void 0;
const ThemeV2_1 = require("../ThemeV2");
const setColorsForThemeV2 = (brandColors, brandName) => {
    return {
        // General Tokens:
        // Interactive
        focus: ThemeV2_1.SystemColors["Color-System-Blue-500"],
        // Stroke Neutral
        "stroke-neutral-default": ThemeV2_1.SystemColors["Color-System-Gray-50"],
        "stroke-neutral-secondary": ThemeV2_1.SystemColors["Color-System-Gray-100"],
        "stroke-neutral-tertiary": ThemeV2_1.SystemColors["Color-System-Gray-200"],
        "stroke-neutral-emphasis": ThemeV2_1.SystemColors["Color-System-Gray-300"],
        // Text Colors
        "text-default": ThemeV2_1.SystemColors["Color-System-Gray-950"],
        // Component Tokens:
        // Button
        "button-surface-filled-enabled": brandColors[`Color-Brand-${brandName}-700`],
        "button-surface-filled-hover": brandColors[`Color-Brand-${brandName}-900`],
        "button-surface-filled-click": brandColors[`Color-Brand-${brandName}-950`],
        "button-surface-filled-disabled": ThemeV2_1.SystemColors["Color-System-Gray-300"],
        "button-onSurface-filled": ThemeV2_1.SystemColors.White,
        "button-onSurface-filled-disabled": ThemeV2_1.SystemColors["Color-System-Gray-50"],
        "button-onSurface-outline-enabled": brandColors[`Color-Brand-${brandName}-700`],
        "button-onSurface-outline-hover": brandColors[`Color-Brand-${brandName}-900`],
        "button-onSurface-outline-click": brandColors[`Color-Brand-${brandName}-950`],
        "button-onSurface-outline-disabled": ThemeV2_1.SystemColors["Color-System-Gray-300"],
        "button-surface-outline": ThemeV2_1.SystemColors.White,
        "button-surface-outline-disabled": ThemeV2_1.SystemColors["Color-System-Gray-50"],
        "button-onSurface-subtle-enabled": brandColors[`Color-Brand-${brandName}-700`],
        "button-onSurface-subtle-hover": brandColors[`Color-Brand-${brandName}-900`],
        "button-onSurface-subtle-click": brandColors[`Color-Brand-${brandName}-950`],
        "button-onSurface-subtle-disabled": ThemeV2_1.SystemColors["Color-System-Gray-300"],
        "button-surface-critical-enabled": ThemeV2_1.SystemColors["Color-System-Red-700"],
        "button-surface-critical-hover": ThemeV2_1.SystemColors["Color-System-Red-900"],
        "button-surface-critical-click": ThemeV2_1.SystemColors["Color-System-Red-950"],
        "button-surface-critical-disabled": ThemeV2_1.SystemColors["Color-System-Gray-300"],
        "button-onSurface-critical": ThemeV2_1.SystemColors.White,
        "button-onSurface-critical-disabled": ThemeV2_1.SystemColors["Color-System-Gray-50"],
        // Feedback
        "feedback-surface-info": ThemeV2_1.SystemColors["Color-System-Blue-50"],
        "feedback-onSurface-incidental-info": ThemeV2_1.SystemColors["Color-System-Blue-500"],
        "feedback-surface-success": ThemeV2_1.SystemColors["Color-System-Green-50"],
        "feedback-onSurface-incidental-success": ThemeV2_1.SystemColors["Color-System-Green-500"],
        "feedback-surface-warning": ThemeV2_1.SystemColors["Color-System-Yellow-50"],
        "feedback-onSurface-incidental-warning": ThemeV2_1.SystemColors["Color-System-Yellow-500"],
        "feedback-surface-critical": ThemeV2_1.SystemColors["Color-System-Red-50"],
        "feedback-onSurface-incidental-critical": ThemeV2_1.SystemColors["Color-System-Red-500"]
    };
};
exports.setColorsForThemeV2 = setColorsForThemeV2;
//# sourceMappingURL=types.js.map